export enum AttendanceStatus {
  Absent,
  Present,
}
